const previous_docs_columns = [
    {text: 'Nome Fantasia', width: '100% ', className: 'text-max-sm'},
    {text: 'Alterar', className: 'text-max-sm px-1 text-center'},
    {text: 'Remover', className: 'text-max-sm px-1 text-center'}
];

export default previous_docs_columns;
